import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

// const generateColors = (count) => {
//   return Array.from({ length: count }, () => {
//     const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
//     return randomColor;
//   });
// };
const generateColors = (count) => {
  const mandatoryColors = ['#69C195', '#F97066', '#98A2B3', '#84BFF3', '#FDB022'];
  if (count <= mandatoryColors.length) return mandatoryColors.slice(0, count);
  return [
    ...mandatoryColors,
    ...Array.from({ length: count - mandatoryColors.length }, () => `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`)
  ];
};

const PieChart = ({ chartData }) => {
  
  // Extracting labels and values dynamically
  const labels =
    chartData &&
    Object.keys(chartData[chartData?.length - 1] || {})
      .filter((key) => key !== "month" && key !== "total") // Exclude "month" and "total"
      .map((key) => `${key} ${chartData[chartData?.length - 1][key] || 0}`);

  const values =
    chartData &&
    Object.entries(chartData[chartData?.length - 1] || {})
      .filter(([key]) => key !== "month" && key !== "total") // Exclude "month" and "total"
      .map(([, val]) => Number(val) || 0);
  
  const backgroundColors = generateColors(labels?.length);
  const data = {
    labels,
    datasets: [
      {
        label: "Provider Types",
        data: values,
        backgroundColor: backgroundColors,
        hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 10,
          padding: 20,
          usePointStyle: true,
        },
      },
    },
    cutout: "60%",
  };

  // Custom plugin for center text
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const {
        ctx,
        data,
        chartArea: { width, height },
      } = chart;
      ctx.save();
      // In this last index is "Invited" number  and i want to not add in this total of last index 
      const total = data.datasets[0].data.slice(0, -1).reduce(
        (acc, value) => acc + Number(value),
        0
      );

      ctx.font = "bold 20px Arial";
      ctx.fillStyle = "#1D2939";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(`${total}`, width / 2, height / 2 - 10);

      ctx.font = "13px Arial";
      ctx.fillText("Total Workers", width / 2, height / 2 + 10);
      ctx.restore();
    },
  };

if(data.labels){
  data.labels = data.labels.map(label => {
    // Match the first word using a regular expression
    const firstWord = label.split(' ')[0];
    
    // Check and update the first word
    if (firstWord === "NonCompliant") {
        return label.replace(firstWord, "Non-Compliant");
    }
    if (firstWord === "SiteAccessApp") {
        return label.replace(firstWord, "Site Access App");
    }
    
    return label;  // Return label unchanged if no match
  });
}

  return (
    <div className="card-body mt-3.5">
      <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
    </div>
  );
};

export default PieChart;
